<script lang="ts" setup>
import { provide, ref, watch } from 'vue';

const loadingCount = ref(0);

defineOptions({
  name: 'OpenLoadingProvider',
});

const emit = defineEmits(['change']);

provide('component-loading-count', loadingCount);

watch(loadingCount, (val) => {
  emit('change', val > 0);
});
</script>

<template>
  <slot :loading="loadingCount > 0"></slot>
</template>

<style lang="scss" scoped>
</style>
